import BrowserDetect from 'services/browser_detect';
import Api from './api';

export default class PushNotificationActions {
  static savePermissionToken(token: any) {
    const browser: any = new BrowserDetect();
    const params = {
      user_device: {
        token: token || null,
        permission: Notification.permission,
        browser: browser.name,
        browser_version: browser.version,
        desktop: browser.desktop,
        mobile: browser.mobile,
        operational_system: browser.os,
        os_version: browser.osVersion,
        user_agent: navigator.userAgent,
      },
    };
    Api.post('/push_notification_user_devices', params);
  }
}
